import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';

export default class BingSiteSearch {
    constructor() {
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
    }

    init(prevLabel, nextLabel) {
        this.q = this.getUrlParam("q");
        this.Pagination = 10;
        this.prevLabel = prevLabel;
        this.nextLabel = nextLabel;
    }

    async search(page = 1) {
        const that = this;

        const url = `${window.location.protocol}//${window.location.host}/Module/BingSiteSearchGet?q=${that.q}&page=${page}`;
        const response = await fetch(url);
        const webPages = await response.json();

        if (!webPages) {
            return;
        }

        that.renderWebList(webPages.Value);
        that.renderPagination(webPages);
    }

    renderWebList(data) {
        const arrWeb = data.map(web => `<li>
                    <div>
                        <div>
                            <a target="_blank" href="${web.Url}">
                                ${web.Name}
                            </a>
                        </div>

                        <div>
                            ${web.Snippet}
                        </div>

                        <div>
                            <a target="_blank" href="${web.Url}">
                              ${web.DisplayUrl}
                            </a>
                        </div>
                    </div>
                </li>`
        );

        document.getElementById("siteSearchResult").innerHTML = arrWeb.join("");
        window.scrollTo(0, 0);
    }

    renderPagination(webPages) {
        const that = this;

        const totalPage = webPages.TotalPage;
        const currentPage = webPages.Page;
        const pagination = that.Pagination;

        let paginations = [];

        const startPagination = that.getStartPagination(currentPage, pagination, totalPage);
        const endPagination = startPagination + pagination - 1;

        for (let i = startPagination; i <= endPagination && i <= totalPage; i++) {
            paginations.push(
                `<li class="${i === currentPage ? "active" : ""}" data-page="${i}">
                    <a ${i !== currentPage ? "onclick=\"cscpjs.default.bingSiteSearchjs.search(" + i + ")\"" : ""}><i>${i}</i></a>
                </li>`
            );
        }

        document.getElementById("siteSearchPagination").innerHTML = `
                <li>
                    <a  ${currentPage !== startPagination ? "onclick=\"cscpjs.default.bingSiteSearchjs.search(" + (currentPage - 1) + ")\"" : "style=\"display:none\""}>
                        <i>${that.prevLabel}</i>
                    </a>
                </li>
                ${paginations.join("")}
                <li>
                    <a ${totalPage !== currentPage ? "onclick=\"cscpjs.default.bingSiteSearchjs.search(" + (currentPage + 1) + ")\"" : "style=\"display:none\""}>
                        <i>${that.nextLabel}</i>
                    </a>
                </li>
        `;

    }

    getStartPagination(currentPage, pagination, totalPage) {
        let startPagination = currentPage - pagination / 2;
        startPagination = startPagination <= 0 ? 1 : startPagination;

        if (totalPage - startPagination < pagination - 1) {
            startPagination = totalPage - pagination + 1;
        }

        startPagination = startPagination <= 0 ? 1 : startPagination;
        return startPagination;
    }


    getUrlParam(paraName) {
        let url = window.location.search.toLocaleLowerCase();
        if (url) {
            url = url.replace("?", "");
            const filterKeyword = paraName.toLocaleLowerCase() + "=";
            const param = url.split("&").find(f => f.indexOf(filterKeyword) === 0)

            if (param) {
                return param.replace(filterKeyword, "");
            }
        }
        return "";
    }
}


// WEBPACK FOOTER //
// ./Scripts/es6/Controllers/bingSiteSearch.js